import { createRefresh } from "react-auth-kit";
import axios from "axios";

const apiUrl =
  process.env.REACT_APP_ENV === "LOCAL"
    ? "http://localhost:5000"
    : "https://api.spotprisprognos.se:8443";

// Must match the server token TTLs (jwt-helpers.ts): access 7d, refresh 30d.
// react-auth-kit ties the auth cookie lifetime to the access value, so keeping
// it multi-day means closing the tab overnight doesn't force a re-login. The
// interval refresh re-reads permissions server-side, so a plan/role change is
// picked up within `interval` minutes and reflected in newAuthUserState.
const ACCESS_TOKEN_MINUTES = 60 * 24 * 7;
const REFRESH_TOKEN_MINUTES = 60 * 24 * 30;

export const refreshApi = createRefresh({
  interval: 10, // minutes — how often permissions are re-synced from the server
  refreshApiCallback: async ({ refreshToken }) => {
    try {
      const res = await axios.post(`${apiUrl}/api/auth/refresh`, { refreshToken });
      const account = res.data.account;
      return {
        isSuccess: true,
        newAuthToken: res.data.accessToken,
        newAuthTokenExpireIn: ACCESS_TOKEN_MINUTES,
        newRefreshToken: res.data.refreshToken,
        newRefreshTokenExpiresIn: REFRESH_TOKEN_MINUTES,
        newAuthUserState: {
          id: account.id,
          email: account.email,
          username: account.username,
          image_link: account.image_link,
          roles: account.roles || [],
          permissions: account.permissions || [],
          permission_version: account.permission_version,
        },
      };
    } catch (e) {
      // Refresh token invalid/expired/revoked — signal failure so react-auth-kit
      // clears auth; the user is then routed to login by RequireAuth.
      return { isSuccess: false, newAuthToken: "" };
    }
  },
});
